import { useTranslation } from "features/translations";
import { useRouter } from "next/router";
import { Container, Icon, PageLink, Paragraph } from "shared/components";

import styles from "./LayoutWidget013.module.scss";

export const LayoutWidget013 = ({ payload }) => {
  const { t } = useTranslation();
  const title = payload?.title ?? "";
  const { pathname } = useRouter();
  const link = pathname.substring(1).split("/")[0] ?? "/";

  return (
    <div className={styles.wrapper}>
      <Container className={styles.inner}>
        <PageLink slug={link} className={styles.link}>
          <span className={styles.arrow}>
            <Icon className={styles.icon} name="arrow_slider_prev" />
          </span>
          <Paragraph className={styles.title} color="dark" uppercase>
            {t(title)}
          </Paragraph>
        </PageLink>
      </Container>
    </div>
  );
};

export default LayoutWidget013;
